import { AppData, Log, Registry, Utils } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning";
import LoadingIcon from "../loading/loading-icon";
import { IDialogueButton, IDialogueInfo } from "../../lib/interfaces";
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from "../../lib/enum";
import { Button, ButtonSmall, FocusManager, NavigationManager, Row, withHandleKey } from "@lightningjs/ui-components";
import { AppSetup } from "../../lib/app-setup";
import Component from "@lightningjs/core/dist/src/application/Component.mjs";

export interface DialogBoxTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class DialogBox
  extends Lightning.Component
  implements Lightning.Component<DialogBoxTemplateSpec> {
  _index: number = -1
  _messageType: string = 'success' // success, warn, error
  enterAnimation!: any
  exitAnimation!: any
  msg!: IDialogueInfo;

  static override _template(): Lightning.Component.Template<DialogBoxTemplateSpec> {
    return {
      PopupBackground: {
        rect: true,
        zIndex:703,
        collision:true,
        color: 0xff222222,
        w: 800,
        h: 300,
        mount: 0.5,
        flex: { direction: 'column', margin: 0 },
        TitleBar: {
          w: (w) => w,
          h: 80,
          zIndex:704,
          rect: true,
          color: 0xffff000000,
          TitleText: {
            x: (w) => w / 2,
            y: (h) => h / 2,
            mount: 0.5,
            text: { paddingLeft: 20, paddingRight: 20, text: '', fontFace: 'Regular', fontSize: 45 }
          }
        },
        Body: {}       
      }
    }
  }

  set messageType(value: string) {
    this._messageType = value
  }

  
  _updateNetworkPopup() {
    this.tag('PopupBackground').patch({
      Body: {
        flexItem: { grow: 1 },
        zIndex:704,
        collision:true,
        Loading: {
          w: 50,
          h: 50,
          x: 75,
          y: 90,
          Icon: {
            scale: 0.5,
            type: LoadingIcon
          }
        },
        Lable: {
          x: 200,
          y: 90,
          h: 40,
          mountY:0.5,
          text: { paddingLeft: 20, paddingRight: 20, text: 'Trying to connect network!', fontFace: 'Regular', fontSize: 36 }
        }
      }
    })
  }

  _updateAlertPopup(): any {
    const {platform} = AppData as AppSetup
    this.tag('PopupBackground').patch({
      Body: {
        flex: { direction: 'column', padding:20, justifyContent: 'center', alignItems: 'center'},
        // flexItem: { grow: 1 },
        collision: true,
        zIndex:704,
        BodyMessage: {
          h:60,
          Lable: {
            h: 40,
            mountX:0.5,
            text: { paddingLeft: 20, paddingRight: 20, text: this.msg.body, fontFace: 'Regular', fontSize: 36 }
          }
        },
        Buttons: {
          h:100,
          y:25,
          zIndex:705,
          collision: true,
          type: FocusManager,
          signals: { 'selectedChange' : 'selectedChange'},
          direction: 'row',
          items: [
            {
              x:-110,
              fixed:true,
              w: this.msg.buttons[0]?.w ? this.msg.buttons[0]?.w : 250,
              type: HoverButton,
              itemIndex:0,
              zIndex:710,
              collision: true,
              signals: {
                handleHover: this.$handleHover
              },
              title: this.msg.buttons[0]?.name,
              action: this.msg.buttons[0],
              style: {
                textStyle: {
                  fontFace: 'Black',
                  fontSize: 30,
                }
              }
            }
          ]
        }
      }
    })
    this.tag('Buttons').Items.zIndex = 708
    this.tag('Buttons').Items.collision = true

    const tts = this.msg.title + this.msg.body + ' ' + this.msg.buttons[0]?.name
    platform?.textToSpeach(tts)
  }

  _updateWithButtonPopup() {
    const {platform} = AppData as AppSetup
    this.tag('PopupBackground').patch({
      Body: {
        flex: { direction: 'column', padding:20, justifyContent: 'center', alignItems: 'center'},
        flexItem: { grow: 1 },
        collision: true,
        zIndex:704,
        BodyMessage: this.msg.body ? {
          h:60,
          rect:true,
          Lable: {
            h: 40,
            mountX:0.5,
            rect:true,
            text: { paddingLeft: 20, paddingRight: 20, text: this.msg.body, fontFace: 'Regular', fontSize: 36 }
          }
        } : {},
        Buttons: {
          h:100,
          zIndex:705,
          y:25,
          collision: true,
          type: FocusManager,
          signals: { 'selectedChange' : 'selectedChange'},
          direction: 'row',
          items: [
            {
              x:-280,
              fixed:true,
              w: this.msg.buttons[0]?.w ? this.msg.buttons[0]?.w : 250,
              type: HoverButton,
              itemIndex:0,
              zIndex:710,
              collision: true,
              signals: {
                handleHover: this.$handleHover
              },
              title: this.msg.buttons[0]?.name,
              action: this.msg.buttons[0],
              style: {
                textStyle: {
                  fontFace: 'Black',
                  fontSize: 30,
                }
              }
            },
            {
              fixed:true,
              x:10,
              w: this.msg.buttons[1]?.w ? this.msg.buttons[1]?.w : 250,
              type: HoverButton,
              itemIndex:1,
              zIndex:710,
              collision: true,
              signals: {
                handleHover: this.$handleHover
              },
              title: this.msg.buttons[1]?.name,
              action: this.msg.buttons[1],
              style: {
                textStyle: {
                  fontFace: 'Black',
                  fontSize: 30,
                  fontsharp:1
                }
              }
            },
          ]
        }
      }
    })
    this.tag('Buttons').Items.zIndex = 708
    this.tag('Buttons').Items.collision = true

    const tts = this.msg.title + this.msg.body + ' ' + this.msg.buttons[0]?.name
    platform?.textToSpeach(tts)
  }

  selectedChange(selected, prevSelected ) {
    const {platform} = AppData as AppSetup
    platform?.textToSpeach(selected.title)
  }
  _update() {
    this.tag('TitleText').text.text = this.msg.title
    const msg: IDialogueInfo = this.msg as IDialogueInfo
    if (this.msg.type == DIALOG_TYPE.NETWORK_BOX) {
      this._updateNetworkPopup()
    } else if(this.msg.type == DIALOG_TYPE.ALERT) {
      this._updateAlertPopup()
    } else {
      this._updateWithButtonPopup()
    }
  }

  override _getFocused() {
    return this.tag('Buttons') || this
  }

  _getBgColor(type: string): any {
    if (type == 'error') {
      return 0xAAF13637
    } else if (type == 'warn') {
      return 0xAAF13637
    }
    return 0xff222222
  }

  override _init() {
    //Log.info('Notification Box _init')
    // this.tag('Label').on('txLoaded', () => {
    //   this.patch({
    //     w: this.tag('Label').renderWidth,
    //     h: this.tag('Label').renderHeight,
    //     color: this._getBgColor(this._messageType)
    //   })
    // })
    this._update()

    this.enterAnimation = this.animation({
      duration: 0.25,
      stopMethod: 'immediate',
      actions: [
        { p: 'alpha', v: { 0: 0.001, 1: 1 } },
      ]
    })

    this.exitAnimation = this.animation({
      duration: 0.25,
      stopMethod: 'immediate',
      actions: [
        { p: 'alpha', v: { 0: 1, 1: 0.001 } },
      ]
    })

    this.enterAnimation.on('finish', () => {
      // Registry.setTimeout(() => {
      //   this.exitAnimation.start()
      // }, 3000)
    })

    this.exitAnimation.on('finish', () => {
      this.getAncestor(1)?.childList.remove(this)
    })

    this.enterAnimation.start()
  }

  override _handleBack(e: KeyboardEvent): boolean | void {
    Log.info('Dialog _handleBack fired')
    const msg: IDialogueInfo = this.msg as IDialogueInfo
    const closeButton:IDialogueButton = {
      w: 0, name: 'Close', action: DIALOG_BUTTON_ACTION.CLOSE,
      index: 0,
      initialFocus: false
    }
    this.fireAncestors('$handleDialogueButtons', msg, closeButton)
    return true
  }

  override _handleKey(e: KeyboardEvent): boolean | void {
    Log.info('Dialog _handleKey fired:', e)
    return true
  }

  override _handleEnter(e: KeyboardEvent): boolean | void {
    const msg: IDialogueInfo = this.msg as IDialogueInfo
    this.fireAncestors('$handleDialogueButtons', msg, this.tag('Buttons').selected.action)
    return true
  }

  
  _handleClick(target) {
   // console.log('Dialog _handleClick: ', target)
    this._handleEnter()
  }

  $handleHover(target) {
   // console.log('Dialog _handleHover: ', target)
    this.tag('Buttons').selectedIndex = target.itemIndex
  }

}

class HoverButton extends ButtonSmall {

  static override _template(): Component.Template {
    return {
      collision: true,
      ...super._template()
    }
  }

  _handleHover(target) {
   // console.log('Dialog _handleHover: ', target)
    this.fireAncestors('$handleHover', target)
  }
}
